// Swiss VAT line/totals math for the invoice entry form. Ports the backend
// money.js cents arithmetic verbatim (lineAmountCents / taxCents) so the
// preview matches the posted invoice to the Rappen: unit prices are NET, every
// line is converted to integer cents first, tax is computed per line on those
// cents and rounded half-up.

/**
 * Computes net / tax / gross totals for editable invoice lines.
 * @param {Array<{ quantity: number|string, unitPrice: number|string, taxRate?: number|string }>} lines
 * @returns {{ net: number, tax: number, gross: number, lineNets: number[], lineTaxes: number[] }}
 */
export function computeInvoiceTotals(lines) {
  const lineNets = [];
  const lineTaxes = [];
  let netCents = 0;
  let taxCents = 0;
  for (const line of lines || []) {
    // Backend lineAmountCents: Math.round(quantity * unitPrice * 100)
    const lineNetCents = Math.round(Number(line.quantity || 0) * Number(line.unitPrice || 0) * 100);
    // Backend taxCents: Math.round(netCents * rate / 100)
    const lineTaxCents = Math.round((lineNetCents * Number(line.taxRate || 0)) / 100);
    lineNets.push(lineNetCents / 100);
    lineTaxes.push(lineTaxCents / 100);
    netCents += lineNetCents;
    taxCents += lineTaxCents;
  }
  return {
    net: netCents / 100,
    tax: taxCents / 100,
    gross: (netCents + taxCents) / 100,
    lineNets,
    lineTaxes,
  };
}
